<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.loadBrowserPrintScript();
  },
  methods: {
    async loadBrowserPrintScript() {
      // Check if BrowserPrint is already loaded
      if (window.BrowserPrint) {
        console.log("✅ BrowserPrint already loaded");
        return;
      }

      try {
        // Create a script tag to load and execute the BrowserPrint library
        const script = document.createElement("script");
        script.type = "text/javascript";

        // Fetch the script content and execute it in global context
        const response = await fetch(new URL("@/libs/utils/BrowserPrint-3.1.250.min.js", import.meta.url));
        let scriptContent = await response.text();
        // Remove core-js imports if present
        //Nose porque agrega esos require en el script y no estan en el archivo original
        scriptContent = scriptContent.replace(/require\("core-js\/modules\/es\.json\.stringify\.js"\);?/g, '');
        scriptContent = scriptContent.replace(/require\("core-js\/modules\/esnext\.json\.parse\.js"\);?/g, '');        

        script.text = scriptContent;
        document.head.appendChild(script);

        // Wait a bit for the script to execute
        await new Promise((resolve) => setTimeout(resolve, 100));

        if (window.BrowserPrint) {
          console.log("✅ BrowserPrint script loaded successfully from local file");
        } else {
          throw new Error("BrowserPrint no se cargó correctamente en window");
        }
      } catch (error) {
        console.error("❌ Failed to load BrowserPrint script from local file:", error);

        // Fallback: try direct execution with eval
        try {
          const module = await import("@/libs/utils/BrowserPrint-3.1.250.min.js?url");
          const response = await fetch(module.default);
          const scriptContent = await response.text();

          // Execute in global context
          eval(scriptContent);

          if (window.BrowserPrint) {
            console.log("✅ BrowserPrint loaded via fallback method");
          } else {
            throw new Error("BrowserPrint fallback también falló");
          }
        } catch (fallbackError) {
          console.error("❌ Fallback also failed:", fallbackError);
          this.handleError("Error al cargar la librería de impresión");
        }
      }
    },
  },
};
</script>
